import {CsvRow} from './types'

export function detectDelimiter(headerLine: string): ',' | ';' | '\t' {
  const commas = (headerLine.match(/,/g) || []).length
  const semicolons = (headerLine.match(/;/g) || []).length
  const tabs = (headerLine.match(/\t/g) || []).length
  if (semicolons > commas && semicolons >= tabs) return ';'
  if (tabs > commas && tabs >= semicolons) return '\t'
  return ','
}

export function splitCSVLine(line: string, delimiter: string): string[] {
  const result: string[] = []
  let current = '',
    inQuotes = false
  for (let i = 0; i < line.length; i++) {
    const char = line[i],
      next = line[i + 1]
    if (char === '"') {
      if (inQuotes && next === '"') {
        current += '"'
        i++
      } else inQuotes = !inQuotes
    } else if (char === delimiter && !inQuotes) {
      result.push(current)
      current = ''
    } else current += char
  }
  result.push(current)
  return result.map((s) => s.trim())
}

export function parseCSV(
  text: string,
  options?: {emptyHeaderFallback?: string},
): {headers: string[]; rows: CsvRow[]} {
  const emptyHeader = options?.emptyHeaderFallback ?? 'Column'
  const normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
  const lines = normalized.split('\n').filter((l) => l.trim().length > 0)
  if (!lines.length) return {headers: [], rows: []}
  const delimiter = detectDelimiter(lines[0])
  const rawHeaders = splitCSVLine(lines[0], delimiter)
  const headers: string[] = []
  const seen: Record<string, number> = {}
  for (const h of rawHeaders) {
    const base = h || emptyHeader
    const count = seen[base] || 0
    const name = count === 0 ? base : `${base}_${count + 1}`
    headers.push(name)
    seen[base] = count + 1
  }
  const rows: CsvRow[] = []
  for (let i = 1; i < lines.length; i++) {
    const parts = splitCSVLine(lines[i], delimiter)
    const row: CsvRow = {}
    headers.forEach((h, idx) => (row[h] = (parts[idx] ?? '').trim()))
    if (Object.values(row).some((v) => v !== '')) rows.push(row)
  }
  return {headers, rows}
}

export function toHumanSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  const kb = bytes / 1024
  if (kb < 1024) return `${kb.toFixed(1)} KB`
  const mb = kb / 1024
  return `${mb.toFixed(1)} MB`
}

export function isValidEmail(email: string): boolean {
  const e = email.trim()
  if (!e) return false
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e)
}
